import {
  Mitarbeiter_UpdateFeiertagskontoEinstellungenMutation,
  Mitarbeiter_UpdateFeiertagskontoEinstellungenMutationVariables,
} from '@/gql/graphql';
import { gql, TypedDocumentNode } from '@apollo/client';

export const UPDATE_FEIERTAGSKONTO_EINSTELLUNGEN: TypedDocumentNode<
  Mitarbeiter_UpdateFeiertagskontoEinstellungenMutation,
  Mitarbeiter_UpdateFeiertagskontoEinstellungenMutationVariables
> = gql`
  mutation mitarbeiter_updateFeiertagskontoEinstellungen(
    $input: mitarbeiter_updateFeiertagskontoEinstellungsInput!
  ) {
    mitarbeiter_updateFeiertagskontoEinstellungen(input: $input) {
      failure {
        message
        type
      }
      success {
        isFeiertagskontoEnabled
      }
    }
  }
`;
